module.exports = __webpack_public_path__ + "img/bid-open-hall-body.236164c3.png";